import { render, staticRenderFns } from "./PlateGameReport.vue?vue&type=template&id=05928354&scoped=true"
import script from "./PlateGameReport.vue?vue&type=script&lang=js"
export * from "./PlateGameReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05928354",
  null
  
)

export default component.exports